// Library
import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

// Components
import Landing from 'components/Landing';
import Step from 'components/Step';
import Loading from 'components/Loading';

// Data
import questions from 'data/questions';
import answers from 'data/answers';
import hobbies from 'data/hobbies';

const MainWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  @media only screen and (max-width: 500px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media only screen and (min-width: 501px) {
    padding-top: 100px;
    max-width: 360px;
  }
`;

const Container = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [taste, setTaste] = useState([]);

  const history = useHistory();

  useEffect(() => {
    setTaste(hobbies);
  }, []);

  const pickBest = (arr) => {
    arr.sort((a, b) => (a.score > b.score ? -1 : b.score > a.score ? 1 : 0));
    let bestIds = [];
    for (let i = 0; i < 3; i++) {
      bestIds.push(arr[i].id);
    }
    return bestIds;
  };

  const addScore = useCallback(
    (answer) => {
      let indexes = [];
      answer.effect.forEach((id) => {
        indexes.push(taste.findIndex((obj) => obj.id === id));
      });
      let tempTaste = [...taste];
      indexes.forEach((idx) => {
        tempTaste[idx] = { ...tempTaste[idx], score: tempTaste[idx].score + 1 };
      });
      setTaste(tempTaste);
    },
    [taste],
  );

  // useCallback 으로 result 변경분 반영
  const onSuccess = useCallback(
    (res) => {
      const r1 = res[0];
      const r2 = res[1];
      const r3 = res[2];
      history.push(`/result?r1=${r1}&r2=${r2}&r3=${r3}`);
    },
    [history],
  );
  const handleSelect = useCallback(
    (answer) => {
      addScore(answer);
      setCurrentStep(currentStep + 1);
      if (currentStep === questions.length) {
        // 마지막 단계까지 오면
        const res = pickBest(taste);
        setTimeout(() => {
          onSuccess(res);
        }, 2000);
      }
    },
    [addScore, currentStep, taste, onSuccess],
  );
  return (
    <MainWrapper>
      {currentStep === 0 ? (
        <>
          <Landing handleStart={() => setCurrentStep(1)} />
        </>
      ) : currentStep <= questions.length ? (
        <>
          <Step
            questionIndex={currentStep}
            question={questions[currentStep - 1]}
            answers={answers.filter((answer) => answer.step === currentStep)}
            handleClick={handleSelect}
            total={questions.length}
          />
        </>
      ) : (
        <>
          <Loading />
        </>
      )}
    </MainWrapper>
  );
};

export default Container;
